//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'PtLoader',
  props: {
    container: {
      type: String,
      default: '',
      description: 'Container that holds the loader, can be any css selector',
    },
    iconClass: {
      type: String,
      default: 'fa-refresh',
      description: 'Font awesome icon class, can be (fa-spinner/fa-refresh/fa-cog/fa-circle-o-notch), pass empty string to hide icon',
    },
    text: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: '',
    },
  },
  data: function data() {
    return {
      containerWidth: 0,
      containerHeight: 0,
    };
  },
  computed: {
    getClasses: function getClasses() {
      return {
        'pt-loader': true,
        'pt-loader-inline': !this.container,
        'pt-loader-full': this.container === 'body',
        'pt-loader-container': !!this.container && this.container !== 'body',
      };
    },
    getStyles: function getStyles() {
      if (!this.container || this.container === 'body') { return ''; }
      if (!this.containerWidth && !this.containerHeight) { return ''; }

      return {
        width: ((this.containerWidth) + "px"),
        height: ((this.containerHeight) + "px"),
      };
    },
  },
  mounted: function mounted() {
    if (!this.container || this.container === 'body') { return ''; }

    var el = document.querySelector(this.container);

    if (el) {
      el.style.position = 'relative';
      this.containerWidth = el.clientWidth;
      this.containerHeight = el.clientHeight;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.container || this.container === 'body') { return ''; }

    var el = document.querySelector(this.container);

    if (el) {
      el.style = '';
    }
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.getClasses, style: _vm.getStyles }, [
    _vm.text
      ? _c("span", { class: _vm.textClass }, [_vm._v(_vm._s(_vm.text))])
      : _vm._e(),
    _vm._v(" "),
    _vm.iconClass
      ? _c("i", { staticClass: "fa fa-spin", class: _vm.iconClass })
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Loader = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Loader as PtLoader };
